import {Component, Input} from '@angular/core';
import {MatDialog} from "@angular/material";
import {kanRemoveDialog} from "../../../../common/dialogs/remove-dialog/component";
import {FileLog} from "../../../../../classes/fileLog";
import {kanFilesService} from "../../../../services/services/files";
import {kanFileLogDialog} from "../../../dialogs/file-log-dialog/component";
import {User} from "../../../../../classes/user";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-user-files',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
})
export class kanUserFiles {
    @Input() private user: User;
    public fileLogs: FileLog[];
    public token: string;

    constructor(private dialog: MatDialog,
                private authService: kanAuthService,
                private filesService: kanFilesService) {

    }

    ngOnInit(): void {
        this.token = this.authService.token;
        this.getFiles();
    }

    get role(): string {
        return this.authService.role;
    }

    public getFiles(): void {
        this.filesService
            .getFileLogs({
                where: {
                    userId: this.user.id
                },
                include: ['dog']
            })
            .then((fileLogs) => {
                this.fileLogs = fileLogs;
            })
            .catch((error) => {
                console.log(error);
            })
    }

    public openDialog(event: any) {
        let dialogRef = this.dialog.open(kanFileLogDialog, {
            data: {
                user: this.user
            },
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getFiles();
            }
        });
    }

    public editFilelogDialog(event, fileLog) {
        let dialogRef = this.dialog.open(kanFileLogDialog, {
            data: {
                user: this.user,
                fileLog: fileLog
            },
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.getFiles();
            }
        });
    }

    public removeFilelog(event, fileLog) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'remove') {
                this.filesService.removeFileLog(fileLog)
                    .then((data) => {
                        this.getFiles();
                    });
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/modules/admin/components/user/files/component.ts